<template>
  <right-panel :datas="connects" @onClose="onClose" ref="right-panel">
    <div slot="header">
      <translate v-if="$route.query.type === 'ecs'">Add Host</translate>
      <translate v-if="$route.query.type === 'rds'">Add Database</translate>
    </div>
    <div slot="content" class="wrapper-padding">
      <el-form ref="form" label-width="110px">
        <el-form-item :label="attrText.selectCluster">
          <el-select v-model="selectedClusterId" value-key filterable @change="onChangeCluster" style="width: 380px; min-width: 100%;">
            <el-option v-for="(item, index) in clusterList" :label="item.name" :value="item.project_id" :key="index" style="width: 380px; min-width: 100%;"></el-option>
            <p v-if="clusterList.length < page.total" class="loadMore" @click="loadMoreCluster" v-loading="loadingMore">
              <translate>Load More</translate>
            </p>
          </el-select>
        </el-form-item>
        <el-form-item :label="attrText.selectInstance">
          <div class="filter-content">
            <el-select class="fitler-key" v-model="filter.key">
              <el-option :label="attrText.name" value="q_name"></el-option>
              <el-option label="IP" value="q_ip"></el-option>
            </el-select>
            <el-input class="filter-value" v-model.trim="filter.value" :placeholder="attrText.input" @keyup.enter.native="onFilter">
              <el-button slot="append" class="filter-btn" @click="onFilter">
                <i class="el-icon-search"></i>
              </el-button>
            </el-input>
          </div>
          <div v-if="resourceLoading" v-loading="resourceLoading" style="height: 100px;"></div>
          <div v-if="resourceList && resourceList.length" class="select-instance">
            <el-checkbox v-model="selectedResourceAll" @change="handleCheckAllChange">
              <translate>All</translate>
            </el-checkbox>
            <div style="margin: 10px 0;"></div>
            <el-checkbox-group v-model="selectedResourceIds" @change="handleCheckedChange">
              <el-checkbox v-for="(item, index) in resourceList" :key="index" :label="item.id">
                {{`${item.name}(${item.ip})`}}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </el-form-item>
        <el-form-item :label="$route.query.type === 'ecs' ? attrText.selectedInstance : attrText.selectedDatabase">
          <div class="resource-selected">
            <div class="no-select" v-if="selectedResourceList.length === 0">
              <translate>No resource selected</translate>
            </div>
            <el-tag
              v-for="tag in selectedResourceList"
              @close="onCloseTag(tag)"
              :key="tag.name"
              :closable="true"
            >
              {{`${tag.name}/(${tag.ip})`}}
            </el-tag>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="detail-btn">
      <el-button type="primary" @click="onSubmit()" :disabled="selectedResourceList.length === 0">
        <translate>Submit</translate>
      </el-button>
      <el-button @click="$refs['right-panel'].onClose()">
        <translate>Cancel</translate>
      </el-button>
    </div>
  </right-panel>
</template>

<script>
  import STORE_CONST from '../../../store/consts'
  import RightPanel from '../../common/right-panel'
  export default{
    name: 'WorkgroupDistributeInstance',
    props: {
      items: {
        required: true
      }
    },
    data () {
      return {
        connects: null,
        clusterList: [],
        selectedClusterId: '',
        selectedCluster: {},
        page: {
          current: 1,
          total: 0
        },
        loadingMore: false,
        resourceList: [],
        resourceLoading: false,
        selectedResourceAll: false,
        selectedResourceIds: [],
        selectedResourceList: [],
        filter: {
          key: 'q_name',
          value: ''
        }
      }
    },
    computed: {
      attrText () {
        return this.getTranslateText()
      }
    },
    created () {
      this.getClusterList()
    },
    methods: {
      // 提取翻译文本
      getTranslateText () {
        return {
          'selectCluster': this.$gettext('Select Cluster'),
          'selectInstance': this.$gettext('Select Resource'),
          'selectedInstance': this.$gettext('Selected Instance'),
          'selectedDatabase': this.$gettext('Selected Database'),
          'hostName': this.$gettext('Host name / IP'),
          'databaseName': this.$gettext('Database name/ IP'),
          'name': this.$gettext('Name'),
          'input': this.$gettext('please input search key'),
          'noData': this.$gettext('No Data')
        }
      },
      onChangeCluster (index) {
        this.selectedCluster = this.clusterList.find(cluster => {
          return cluster.project_id === index
        })
        // 清空之前cluster的数据
        this.selectedResourceIds = []
        this.resourceList = []
        this.filter.value = ''
      },
      // 加载更多
      loadMoreCluster () {
        this.loadingMore = true
        this.getClusterList(++this.page.current)
      },
      // 获取集群列表
      getClusterList (page) {
        let params = {
          params: {
            page: page || 1,
            page_size: 20
          }
        }
        this.$store.dispatch(STORE_CONST.CLUSTER.GET_CLUSTER, params).then((res) => {
          this.loadingMore = false
          this.page.total = res.total
          let clusterArr = res.objects.map((item) => {
            return {
              id: item.id,
              project_id: item.project_id,
              name: item.name
            }
          })
          if (!clusterArr.length) return
          this.selectedCluster = clusterArr[0]
          if (this.clusterList.length) {
            this.clusterList = this.clusterList.concat(clusterArr)
          } else {
            this.clusterList = clusterArr
            this.selectedClusterId = clusterArr[0].project_id
          }
        })
      },
      // 获取某集群下的资源列表
      getClusterResources () {
        this.resourceLoading = true
        const projectId = this.selectedCluster.project_id
        let params = {
          id: projectId,
          params: {
            type: this.$route.query.type,
            exclude_pid: this.$route.params.id,
            page_size: 50
          }
        }
        if (this.filter.key && this.filter.value) {
          params.params[this.filter.key] = this.filter.value
        }
        this.$store.dispatch(STORE_CONST.WORKGROUP.LIST_WORKGROUP_RESOURCE, params).then(res => {
          this.resourceLoading = false
          this.resourceList = res.objects
          let idArr = []
          this.resourceList.forEach(item => {
            const findItem = this.selectedResourceList.find(_ => _.id === item.id)
            if (findItem) {
              idArr.push(findItem.id)
            }
          })
          this.selectedResourceIds = idArr
          if (this.selectedResourceIds.length === this.resourceList.length) {
            this.selectedResourceAll = true
          } else {
            this.selectedResourceAll = false
          }
        })
      },
      onFilter () {
        if (!this.filter.key || !this.filter.value) return
        this.getClusterResources()
      },
      // 全选改变事件
      handleCheckAllChange (value) {
        if (this.selectedResourceAll) { // 全选
          this.resourceList.forEach(item => {
            const findItem = this.selectedResourceList.find(_ => _.id === item.id)
            const findId = this.selectedResourceIds.find(id => id === item.id)
            if (!findItem) {
              this.selectedResourceList = this.selectedResourceList.concat([item])
            }
            if (!findId) {
              this.selectedResourceIds = this.selectedResourceIds.concat([item.id])
            }
          })
        } else { // 全不选
          this.resourceList.forEach(item => {
            const findIndex = this.selectedResourceList.findIndex(_ => _.id === item.id)
            const findIdIndex = this.selectedResourceIds.findIndex(id => id === item.id)
            if (findIndex >= 0) {
              this.selectedResourceList.splice(findIndex, 1)
            }
            if (findIdIndex >= 0) {
              this.selectedResourceIds.splice(findIdIndex, 1)
            }
          })
        }
      },
      // 单选改变事件
      handleCheckedChange (values) {
        if (values.length === this.resourceList.length) {
          this.selectedResourceAll = true
        } else {
          this.selectedResourceAll = false
        }
        this.resourceList.forEach(item => {
          const findIndex1 = values.findIndex(id => id === item.id)
          const findIndex2 = this.selectedResourceList.findIndex(_ => _.id === item.id)
          if (findIndex1 < 0 && findIndex2 >= 0) {
            this.selectedResourceList.splice(findIndex2, 1)
          } else if (findIndex1 >= 0 && findIndex2 < 0) {
            this.selectedResourceList = this.selectedResourceList.concat([item])
          }
        })
      },
      // 关闭tag
      onCloseTag (resource) {
        const findIndex = this.selectedResourceList.findIndex(item => item.id === resource.id)
        const findIdIndex = this.selectedResourceIds.findIndex(id => id === resource.id)
        if (findIndex >= 0) {
          this.selectedResourceList.splice(findIndex, 1)
        }
        if (findIdIndex >= 0) {
          this.selectedResourceIds.splice(findIdIndex, 1)
        }
        if (this.selectedResourceIds.length === this.resourceList.length) {
          this.selectedResourceAll = true
        } else {
          this.selectedResourceAll = false
        }
      },
      // 提交分配主机
      onSubmit () {
        let params = {
          projectId: this.$route.params.id,
          data: {
            resources: []
          }
        }
        this.selectedResourceList.forEach(item => {
          params.data.resources.push(item.id)
        })
        this.$store.dispatch(STORE_CONST.WORKGROUP.ADD_WORKGTOUP_RESOURCE, params).then(res => {
          this.$emit('callback')
          this.$refs['right-panel'].onClose()
          this.$notify({
            message: this.$gettext('Add Successfully!'),
            type: 'success'
          })
        }).catch(err => {
          if (err.code === 'ResourceExceeded') {
            this.$notify({
              type: 'error',
              message: this.$gettext('ResourceExceeded.')
            })
          }
        })
      },
      // 关闭侧滑
      onClose () {
        this.connects = null
        this.$emit('onClosePanel')
      }
    },
    watch: {
      'items': {
        handler: function (newVal) {
          if (this.connects) {
            this.connects = null
            setTimeout(() => {
              this.connects = this.items
            }, 300)
          } else {
            this.connects = this.items
          }
        },
        deep: true
      }
    },
    components: {
      RightPanel
    }
  }
</script>

<style lang='scss' rel="stylesheet/scss">
  @import "../../../assets/css/variable";

  .wrapper-padding {
    padding: 20px 20px 0;
  }

  .select-instance {
    border: 1px solid $border-color;
    padding: 0 10px;
    max-height: 400px;
    overflow: auto;
    .no-resource {
      text-align: center;
    }
    .el-checkbox {
      display: block;
    }
    .el-checkbox + .el-checkbox {
      margin-left: 0;
    }
  }

  .resource-selected {
    border-top: 1px solid $border-color;
    padding-top: 10px;
    max-height: 500px;
    overflow: auto;
    .no-select {
      text-align: center;
    }
    .el-tag {
      position: relative;
      display: block;
      margin-bottom: 10px;
      background-color: #fff;
      color: $textColor;
      border: 1px solid $border-color;
      height: 36px;
      line-height: 36px;
      border-radius: 0;
      .el-icon-close {
        position: absolute;
        display: inline-block;
        height: 38px;
        width: 38px;
        line-height: 38px;
      }
    }
  }
  .loadMore {
    padding: 8px 0px;
    text-align: center;
    cursor: pointer;
    &:hover{
      color: #20a0ff;
    }
  }
  .filter-content {
    display: flex;
    align-items: center;
    .fitler-key {
      display: inline-block;
      margin-right: 10px;
      width: 100px;
    }
    .filter-value {
      .el-input-group__append {
        border-radius: 0px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// workgroup-distribute-instance.vue?2b484eee